<template>
  <div class="column">
    <div class="card" style="margin-top:2px;">
      <div class="card-header">
        <div class="container pec-header">
          <div id="headtext2">{{ getKpiProcessExcellenceKpiName }}</div>
          <performanceitem id="headkpi"
                           :overallByWave="getOverallByWave"
                           :kpi="getKpiProcessExcellence"></performanceitem>
          <WideNscItem :overallByWave="getOverallByWave"
                       :kpi="getKpiProcessExcellence" />
        </div>
      </div>

      <div class="card-body" >

        <div class="il-table">
          <div class="il-row col-15" >
            <!-- Cluster 1 -->
            <div class="il-cell col-3">
              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiContact"
                         :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiAutoResponse"
                           :hasStar="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiPersonalResponse4hrs"
                           :hasStar="true"/>

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiPersonalResponse2days"
                           :hasDashBorder="true" />

                <div class="subitemlostleadsstyle" id="dimmedout">
                  <tableitem :invertArrow="true"
                            :overallByWave="getOverallByWave"
                            :kpi="getKpiLostLeads"
                            :monochrome="true" />
                </div>

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiQualityOfResponseStandards"
                           :hasStar="true"/>

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiAttemptAppointment"
                           :hasStar="true"/>

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiAnswerRefersToEnquiry"
                           :hasStar="false"/>
              </div>
            </div>

            <!-- Cluster 2 -->
            <div class="il-cell  col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getSalesConsultation"
                         :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiVehiclePresentation"
                           :hasDashBorder="true" />

                <div id="dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                            :kpi="getKpiEnquiryReference"
                            :monochrome="true" />
                </div>

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiWelcomeToTheDealership"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiNeedAnalysis"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiConfigurationAssistance"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiUseOfPhysicalVehicleVirtualTool"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiProvisionofProductInformation"
                           :hasDashBorder="false" />
              </div>
            </div>

            <!-- Cluster 3 -->
            <div class="il-cell  col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiTestDrive"
                         :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiTestDriveOffer"
                           :hasStar="true"
                           :hasDashBorder="true" />
              <!-- Unterschied zw. "03. Test Drive Offer" und "06. Test Drive Offer"?
              <tableitem :kpi="dashdata.KPI[16]" :hasStar="true"></tableitem>-->

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiTDProcedureRequirements"
                           :hasStar="false"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiConditionOfTDVehicle"
                           :hasStar="false"
                           :hasDashBorder="false" />
              </div>

            </div>

            <!-- Cluster 4 -->
            <div class="il-cell  col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiOffer"
                         :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiRetailLeadDoc"
                           :hasStar="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiFinancingProductOffer"
                           :hasStar="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiNewCarOffer"
                           :hasStar="true"
                           :hasDashBorder="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiProvisionOfPriceInformation"
                           :hasStar="false"
                           :hasDashBorder="false" />
              </div>

            </div>

            <!-- Cluster 5 -->
            <div class="il-cell  col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiFollowUp"
                         :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <!-- Unterschied zw. "05. Follow-up on Offer" und "09. Follow-up on Offer"? -->
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiFollowUpOnOffer"
                           :hasStar="true"
                           :hasDashBorder="true" />

                <div  id="dimmedout">
                  <tableitem :overallByWave="getOverallByWave"
                             :kpi="getKpiFollowUpByPhone48h"
                             :monochrome="true" />

                  <tableitem :overallByWave="getOverallByWave"
                             :kpi="getKpiFollowUpByPhone24h"
                             :monochrome="true" />
                </div>

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiCourtesyTextMessage"
                           :hasStar="false"
                           :hasDashBorder="false" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiAskingForDecision"
                           :hasStar="false"
                           :hasDashBorder="false" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import WideNscItem from './WideNscItem.vue'
  import titleunderline from './TitleUnderline'

  export default {
    name: 'ProcessExcellenceColumn',
    data: function(){
      return {
        kpi1 : {}
      }
    },

    components: {
      performanceitem,
      tableitem,
      WideNscItem,
      titleunderline
    },

    props:{
      dashdata: Object,
      isUsedCar: Boolean
    },

    methods:{
      getKpiByString: function (name) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0) {
          let item = _.find(this.dashdata.KPI, (x) => x.KpiCode === name)
          if (item) return item
        }
      },
      getKpiGroupByString: function (name) {
        if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
          return _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === name)
      },
    },

    computed: {

      getOverallByWave: function() {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      getKpiProcessExcellence: function () {
        return this.getKpiGroupByString('Process Excellence')
      },

      isKpiProcessExcellenceVisible: function () {
        var _kpi = this.getKpiProcessExcellence
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result =  _kpi.SurveyWave[0].ResultNSC
        return result  != undefined
      },

      getKpiProcessExcellenceKpiName: function() {
        var item = this.getKpiProcessExcellence
        if (item) {
          return item.KpiName
        }
      },

      // Cluster 1: Contact Column
      getKpiContact: function() {
        return this.getKpiByString('01. Contact')
      },
      getKpiAutoResponse: function() {
        return this.getKpiByString('01. Auto Response (instantly)')
      },
      getKpiPersonalResponse4hrs: function() {
        return this.getKpiByString('02. Personal Response within 4 hrs')
      },
      getKpiPersonalResponse2days: function() {
        return this.getKpiByString('01. Personal response within 2 working days')
      },
      getKpiLostLeads: function() {
        return this.getKpiByString('Lost Leads')
      },
      getKpiQualityOfResponseStandards: function() {
        return this.getKpiByString('03. Quality of Response: Standards')
      },
      getKpiAttemptAppointment: function() {
        return this.getKpiByString('04. Attempt to make an Appointment')
      },
      getKpiAnswerRefersToEnquiry: function() {
        return this.getKpiByString('1.5 Answer refers to enquiry') // 36/43 kpi
      },

      // Cluster 2: Sales Consultation Column
      getSalesConsultation: function() {
        return this.getKpiByString('02. Sales consultation')
      },
      getKpiVehiclePresentation: function() {
        return this.getKpiByString('02. Vehicle Presentation')
      },
      getKpiEnquiryReference: function() {
        return this.getKpiByString('Enquiry Reference')
      },
      getKpiWelcomeToTheDealership: function() {
        return this.getKpiByString('2.1 Welcome to the dealership') // 36/43 kpi
      },
      getKpiNeedAnalysis: function() {
        return this.getKpiByString('2.2 Need analysis') // 36/43 kpi
      },
      getKpiConfigurationAssistance: function() {
        return this.getKpiByString('2.3 Configuration assistance') // 36/43 kpi
      },
      getKpiUseOfPhysicalVehicleVirtualTool: function() {
        return this.getKpiByString('2.5 Use of phyical vehicle/virtual tool') // 36/43 kpi
      },
      getKpiProvisionofProductInformation: function() {
        if (!this.isUsedCar) {
          return this.getKpiByString('2.6 Provision of product information') // 36/43 kpi
        }
        return this.getKpiByString('2.4 Provision of product information') // 36/43 kpi
      },

      // Cluster 3: Test Drive Column
      getKpiTestDrive: function() {
        return this.getKpiByString('03. Test Drive')
      },
      getKpiTestDriveOffer: function() {
        return this.getKpiByString('03. Test Drive Offer')
      },
      getKpiTDProcedureRequirements: function() {
        return this.getKpiByString('3.2 TD procedure requirements') // 36/43 kpi
      },
      getKpiConditionOfTDVehicle: function() {
        return this.getKpiByString('3.3 Condition of TD vehicles') // 36/43 kpi
      },


      // Cluster 4: Offer Column
      getKpiOffer: function() {
        return this.getKpiByString('04. Offer')
      },
      getKpiRetailLeadDoc: function() {
        return this.getKpiByString('05. Retail Lead Documentation')
      },
      getKpiFinancingProductOffer: function() {
        return this.getKpiByString('08. Financing Product Offer given')
      },
      getKpiNewCarOffer: function() {
        return this.getKpiByString('04. New Car Offer given')
      },
      getKpiProvisionOfPriceInformation: function() {
        return this.getKpiByString('4.2 Provision of price information')
      },


      // Cluster 5: FollowUp Column
      getKpiFollowUp: function() {
        return this.getKpiByString('05. Follow-up')
      },
      getKpiFollowUpOnOffer: function() {
        return this.getKpiByString('05. Follow-up on Offer')
      },
      getKpiFollowUpByPhone24h: function() {
        return this.getKpiByString('Follow-up via phone (24h)')
      },
      getKpiFollowUpByPhone48h: function() {
        return this.getKpiByString('Follow-up via phone (48h)')
      },
      getKpiCourtesyTextMessage: function() {
        return this.getKpiByString('5.1 Courtesy text message')
      },
      getKpiAskingForDecision: function() {
        return this.getKpiByString('5.6 Asking for decision')
      }

    }
  }

</script>

<style scoped>

  #headtext2 {
    height: 24pt;
    text-align: center;
    color: #111111;
    position: relative;
    top: -6px;
    display: inline-block;
    font-weight: 500;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  .column {
    margin: 0px;
    padding: 0px;
    position: relative;
    top: 0px;
    margin-block-end: 0px;
    margin-inline-end: 0px;
  }

  .subitemlostleadsstyle {
    margin-inline-start: 36px;
  }

  .col-3{
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    border-width: 0px;
  }

  .card-header:first-child {
    border-radius: 0rem;
    margin: 0px;
    padding: 0px;
  }

  .card-header {
    background: #d9d9d9;
    border-width: 0px;
    margin: 0px;
    height: 40px;
  }

  .pec-header {
    width: 750px;
    padding-right: 0px;
    padding-left: 0px;
  }

  .card-body {
    padding: 0px;
    margin: 0px;
  }

  .card {
    border: solid #bfbfbf;
    border-width: 2px;
    border-radius: 0rem;
    margin-top: 2px;
    padding: 0px;
    padding-left: 44px;
    height:764px;
  }

  .il-table{
    font-size: 9pt;
    font-size-adjust: inherit;
    height: fit-content;
    width: 100%;
    display: table;
  }

  .il-row {
    width: 100%;
    float: left;
  }

  #dimmedout {
    opacity: 0.5;
    filter: alpha(opacity=50);
  }

  .il-cell {
    float: left;
    width: 20%;
    text-overflow: ellipsis;
    display: table-cell;
  }

  .pec-card{
    float: left;
  }

  .card {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding: 0px;
  }

  h3{
    height: 36pt;
    line-height: 28pt;
    text-align: center;
    float: left;
    top: 0px;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

</style>
